import styled from "@emotion/styled";
import { DESKTOP } from "@/themes/device";
import { grayScale, mHeader1, wHeader2 } from "@teamsparta/design-system";

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 328px;

  ${DESKTOP} {
    width: initial;
    max-width: 1152px;
  }
`;

export const Title = styled.h3`
  ${mHeader1};
  margin-bottom: 40px;
  ${DESKTOP} {
    ${wHeader2};
    text-align: center;
    margin-bottom: 80px;
  }
`;

export const Cards = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${DESKTOP} {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: initial;
  }
`;
